(function tdMobilePurchaseFixes() {
  if (window.__tdMobilePurchaseFixesLoaded) return;
  window.__tdMobilePurchaseFixesLoaded = true;

  const SELECTORS = {
    stickyAtc: 'sticky-atc',
    productInfo: 'product-info[id^="MainProduct"], product-info',
    quickAddModal: 'quick-add-modal',
    popupModal: 'modal-dialog.product-popup-modal',
    mediaModal: 'product-modal',
    modalScrollable: '.quick-add-modal__content-info, .product-popup-modal__content, .product-popup-modal__content-info',
  };
  const CLASSES = {
    modalOpen: 'td-modal-open',
    stickyVisible: 'td-sticky-atc-visible',
  };
  const MOBILE_BREAKPOINT = '(max-width: 749px)';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  function setViewportHeightVar() {
    document.documentElement.style.setProperty('--td-app-height', `${window.innerHeight}px`);
  }

  function anyModalIsOpen() {
    return Boolean(document.querySelector(`${SELECTORS.quickAddModal}[open], ${SELECTORS.popupModal}[open], ${SELECTORS.mediaModal}[open]`));
  }

  function syncBodyModalState() {
    document.body.classList.toggle(CLASSES.modalOpen, anyModalIsOpen());
  }

  function resetModalScroll(modal) {
    modal.querySelectorAll(SELECTORS.modalScrollable).forEach((element) => {
      element.scrollTop = 0;
    });
  }

  function observeModalState() {
    const modals = document.querySelectorAll(
      `${SELECTORS.quickAddModal}, ${SELECTORS.popupModal}, ${SELECTORS.mediaModal}`
    );

    if (!modals.length) {
      syncBodyModalState();
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(({ target }) => {
        if (target.hasAttribute('open')) {
          resetModalScroll(target);
        }
      });

      syncBodyModalState();
    });

    modals.forEach((modal) => {
      observer.observe(modal, {
        attributes: true,
        attributeFilter: ['open'],
      });
    });

    syncBodyModalState();
  }

  function initializeStickyAtc() {
    const stickyAtc = document.querySelector(SELECTORS.stickyAtc);
    const productInfo = document.querySelector(SELECTORS.productInfo);

    if (!stickyAtc || !productInfo) return;

    const mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);
    const mainForm = productInfo.querySelector('form[data-type="add-to-cart-form"]');
    const stickyForm = stickyAtc.querySelector('form[data-type="add-to-cart-form"]');
    const mainVariantInput = mainForm?.querySelector('input[name="id"]');
    const stickyVariantInput = stickyForm?.querySelector('input[name="id"]');
    const mainSubmit = mainForm?.querySelector('.product-form__submit');
    const stickySubmit = stickyForm?.querySelector('.product-form__submit');
    const stickyTrigger =
      stickyAtc.querySelector('.selected-variant')?.parentElement || stickyAtc.querySelector('.selected-variant');

    if (!stickyVariantInput || !stickySubmit) return;

    function syncVariantInput(variantId) {
      const nextVariantId = variantId || mainVariantInput?.value || '';
      stickyVariantInput.value = nextVariantId;
      stickyVariantInput.disabled = !nextVariantId || stickySubmit.disabled;
      stickyVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function syncSubmitState() {
      if (!mainSubmit) return;

      const isDisabled =
        mainSubmit.disabled ||
        mainSubmit.hasAttribute('disabled') ||
        mainSubmit.getAttribute('aria-disabled') === 'true';

      stickySubmit.disabled = isDisabled;
      stickySubmit.toggleAttribute('aria-disabled', isDisabled);
      stickyVariantInput.disabled = isDisabled || !stickyVariantInput.value;
    }

    function syncStickyVisibility() {
      const isVisible =
        mediaQuery.matches &&
        stickyAtc.classList.contains('active') &&
        !stickyAtc.classList.contains('hidden') &&
        !document.body.classList.contains(CLASSES.modalOpen);

      document.body.classList.toggle(CLASSES.stickyVisible, isVisible);
    }

    function syncStickyHeight() {
      document.documentElement.style.setProperty('--td-sticky-atc-height', `${stickyAtc.offsetHeight}px`);
      syncStickyVisibility();
    }

    function syncFromMainForm() {
      syncVariantInput(mainVariantInput?.value);
      syncSubmitState();
      syncStickyHeight();
    }

    function scrollToProductInfo() {
      productInfo.scrollIntoView({
        behavior: mediaQuery.matches ? 'smooth' : 'auto',
        block: 'start',
      });
    }

    if (stickyTrigger) {
      stickyTrigger.setAttribute('data-td-sticky-scroll-target', '');
      stickyTrigger.setAttribute('role', 'button');
      stickyTrigger.setAttribute('aria-controls', productInfo.id);

      if (!stickyTrigger.hasAttribute('tabindex')) {
        stickyTrigger.tabIndex = 0;
      }

      stickyTrigger.addEventListener('click', scrollToProductInfo);
      stickyTrigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        scrollToProductInfo();
      });
    }

    if (mainVariantInput) {
      mainVariantInput.addEventListener('change', syncFromMainForm);
    }

    if (mainSubmit) {
      new MutationObserver(syncFromMainForm).observe(mainSubmit, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
      });
    }

    new MutationObserver(syncStickyVisibility).observe(stickyAtc, {
      attributes: true,
      attributeFilter: ['class'],
    });

    if (window.ResizeObserver) {
      new ResizeObserver(syncStickyHeight).observe(stickyAtc);
    }

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', syncStickyVisibility);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(syncStickyVisibility);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        syncVariantInput(event?.data?.variant?.id);
        window.requestAnimationFrame(syncFromMainForm);
      });

      subscribe(PUB_SUB_EVENTS.variantUnavailable, () => {
        window.requestAnimationFrame(syncFromMainForm);
      });
    }

    syncFromMainForm();
  }

  onReady(() => {
    setViewportHeightVar();
    observeModalState();
    initializeStickyAtc();
  });

  window.addEventListener('resize', setViewportHeightVar, { passive: true });
})();
